/**
 * Round 16 K12 -- the restore, as the dossier cover prints it.
 *
 * Settings printed the operator's typed line as when the restore was
 * last exercised, with no second line and no disagreement, while the
 * product's own record of a restore sat in the audit trail linked to
 * nothing; Bank Setup printed neither. Both now print the typed line,
 * the recorded one, and say when they disagree. With nothing recorded
 * the typed line stands alone.
 */
import { useTranslation } from "react-i18next";

import type { RestoreRecord } from "shared/api/types";
import { formatDate } from "shared/time/formatDate";

export function RestoreRecordNote({
  restore,
}: {
  restore: RestoreRecord | null | undefined;
}) {
  const { t } = useTranslation();
  if (!restore) return null;
  return (
    <div data-testid="restore-record" className="space-y-0.5 text-xs text-slate-600">
      <p data-testid="restore-record-stated">
        {t("screens.restoreRecord.stated", {
          line: restore.stated ?? t("screens.restoreRecord.notStated"),
        })}
      </p>
      <p data-testid="restore-record-recorded">
        {restore.recorded_at
          ? t("screens.restoreRecord.recorded", {
              date: formatDate(restore.recorded_at),
            })
          : t("screens.restoreRecord.notRecorded")}
      </p>
      {restore.disagree && (
        <p data-testid="restore-record-disagree" className="font-medium text-amber-800">
          {t("screens.restoreRecord.disagree")}
        </p>
      )}
    </div>
  );
}
